import React from "react";

export const ErrorPage = () => {
  return <div>ErrorPage</div>;
};
